module.exports = __webpack_public_path__ + "img/fa-brands-400.4b0e8720.svg";